import ErrorMessage from "@medoma/components/ErrorMessage/ErrorMessage";
import { Loading } from "@medoma/components/Loading/Loading";
import { hasAuthParams, useAuth } from "react-oidc-context";
import { Navigate, useLocation } from "react-router";
import { useCallback, useEffect } from "react";
import styles from "./login.module.scss";
import * as Sentry from "@sentry/react";
import { useLingui } from "@lingui/react/macro";

export const Login = () => {
  const auth = useAuth();
  const { activeNavigator, error, isAuthenticated, isLoading, user } = auth;

  const { state }: { state?: { from?: Location } } = useLocation();
  const { t } = useLingui();
  const redirectURL =
    // If there is a state in the user object, it means that the user was redirected to the login page, and this is where they came from. Respect that firstly.
    // If there is a from in the state object, it means that the user was redirected internally, and this is where they came from. Respect that secondly.
    // Default to root.
    user?.state
      ? user?.state
      : state?.from
        ? `${state?.from?.pathname}${state?.from?.search}`
        : "/";

  const signin = useCallback(() => {
    void auth.signinRedirect({
      state: redirectURL,
    });
  }, [auth, redirectURL]);

  // automatically sign-in
  useEffect(() => {
    if (
      !hasAuthParams() &&
      !isAuthenticated &&
      !activeNavigator &&
      !isLoading
    ) {
      signin();
    }
  }, [isAuthenticated, activeNavigator, isLoading, signin]);

  if (isAuthenticated) {
    return <Navigate to={redirectURL} replace />;
  }

  if (activeNavigator || isLoading) {
    return (
      <div className={styles.login}>
        <Loading message={t`Loggar in`} />
      </div>
    );
  }

  if (error) {
    Sentry.captureException(error);
    return (
      <div className={styles.login}>
        <ErrorMessage message={t`Det gick inte att logga in`} />
      </div>
    );
  }

  return null;
};
